(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breakout-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-lifestyle')) {
  customElements.define('bb-lifestyle', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const subscription = this.querySelector('[data-bbl-subscription]');
      const select = this.querySelector('[data-bbl-plan]');
      const once = this.querySelector('[data-bbl-purchase][value="once"]');
      const subscribe = this.querySelector('[data-bbl-purchase][value="subscribe"]');
      const schedule = this.querySelector('[data-bbl-schedule]');
      const terms = this.querySelector('[data-bbl-terms]');
      const syncPurchase = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        if (!option) { once.checked = true; subscribe.disabled = true; }
        else { subscribe.disabled = false; }
        const active = subscribe.checked && !!option;
        select.disabled = !active;
        schedule.hidden = !active;
        if (option) {
          this.querySelector('[data-bbl-sub-price]').textContent = option.dataset.firstPrice;
          terms.textContent = terms.dataset.template.replace('[first]', option.dataset.firstPrice).replace('[regular]', option.dataset.recurringPrice).replace('[interval]', option.textContent.trim());
        }
      };
      const syncPack = () => {
        const radio = this.querySelector('input[type="radio"][name="id"]:checked');
        if (!radio) return;
        const image = this.querySelector('.bbl__main-image');
        if (image) { image.removeAttribute('srcset'); image.src = radio.dataset.photo; image.alt = radio.dataset.title; }
        const button = this.querySelector('button[type="submit"]');
        button.disabled = radio.dataset.available !== 'true';
        const buyLabel = this.querySelector('[data-buy-label]');
        if (button.disabled) buyLabel.textContent = 'Sold out';
        else buyLabel.textContent = 'Add to bag';
        if (select) {
          const interval = select.selectedOptions[0]?.textContent.trim();
          const template = this.querySelector('template[data-bbl-plan-template="' + radio.value + '"]');
          select.replaceChildren(...(template ? Array.from(template.content.children).map(node => node.cloneNode(true)) : []));
          const matchingOption = Array.from(select.options).find(option => option.textContent.trim() === interval);
          if (matchingOption) select.value = matchingOption.value;
          subscription.hidden = select.options.length === 0;
          syncPurchase();
        }
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-select-pack]');
        if (link) this.querySelector('input[data-pack-count="' + link.dataset.selectPack + '"]')?.click();
      });
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"][name="id"]')) syncPack();
        if (event.target.matches('[data-bbl-purchase], [data-bbl-plan]')) syncPurchase();
      });
      this.querySelector('.bbl__form')?.addEventListener('submit', event => {
        if (subscribe?.checked && (!select || select.disabled || !select.value)) event.preventDefault();
      });
      syncPack();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
